import type { ReactNode } from 'react';
import { FormControlLabel } from '@mui/material';

import { Switch } from '@theguarantors/tg-package-material-ui';

import { createDataTestId } from '@/utils/createDataTestId';

import { useLeaseField } from '../../hooks/use-lease-field';

export type LeaseSwitchInputProps = {
  name: string;
  label?: ReactNode;
  disabled?: boolean;
  onChangeValue?: (checked: boolean) => void;
};

// Boolean toggle bound to RHF via `useLeaseField`. Stores a boolean in form
// state (unlike the string-valued primitives).
export function LeaseSwitchInput({
  name,
  label,
  disabled = false,
  onChangeValue,
}: LeaseSwitchInputProps) {
  const field = useLeaseField<boolean | null | undefined>(name);
  const checked = Boolean(field.value);
  const dataTestId = createDataTestId({ inputString: name, suffix: 'switch' });

  const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, nextChecked: boolean) => {
    field.onChange(nextChecked);
    onChangeValue?.(nextChecked);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={handleChange}
          onBlur={field.onBlur}
          slotProps={{ input: { ref: field.ref } }}
          disabled={disabled}
          id={dataTestId}
          data-testid={dataTestId}
        />
      }
      label={label ?? ''}
    />
  );
}
